<template>
  <div class="" id="switchcontact">
    <div class="container py-5">
      
      <h2>Switch Agents Today</h2>
        <p>Pop your details into the form below and we'll be in touch</p>

        <form>
                <div class="form-row">
                  <div class="form-group col-sm-12">
                    <input
                      type="text"
                      ref="name"
                      name="name"
                      value=""
                      placeholder="Name"
                      class="form-control"
                    />
                    <input type="text" style="display: none;" ref="lastname" name="lastname" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-sm-6">
                    <input type="hidden" ref="address" name="address" />
                    <input
                      type="text"
                      ref="email"
                      name="email"
                      value=""
                      placeholder="Email"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-6">
                    <input
                      type="text"
                      ref="phone"
                      name="phone"
                      value=""
                      placeholder="Phone"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-row" style='margin-top: 10px;'>
                  <div class="form-group col-md-12 col-lg-4">
                    <strong>I feel like a</strong>
                  </div>
                  <div class="form-group col-md-6 col-lg-4">
                    <div class="form-check ml-3">
                      <input
                        type="radio"
                        ref="coffee"
                        name="beverage[]"
                        value="coffee"
                        class="form-check-input"
                        checked
                      />
                      <label for="" class="form-check-label text-primary">
                        <span class="fa fa-coffee"></span> Coffee
                      </label>
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-lg-4">
                    <div class="form-check ml-3">
                      <input
                        type="radio"
                        ref="beer"
                        name="beverage[]"
                        value="beer"
                        class="form-check-input"
                      />
                      <label for="" class="form-check-label text-primary">
                        <span class="fa fa-beer"></span> Beer
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-sm-12">
                    <textarea
                      name="message"
                      class="form-control"
                      ref="message"
                      placeholder="Message"
                      rows="2"
                    ></textarea>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group-12 col-sm-12">
                    <button
                      class="btn"
                      ref="submitButton"
                      type="button"
                      @click="sendEmail()"
                    >
                      Get in touch
                    </button>
                  </div>
                </div>
              </form>
      
    </div>
  </div>
</template>

<style lang="scss">
#switchcontact {
    padding-top: 60px;
    padding-bottom: 60px;
    position: relative;
    
    .container {
        position: relative;
        z-index: 9;
        max-width: 800px;
        text-align: center;
    }
    
    input[type=text], textarea, select, button {
        position: relative;
        font-size: 18px;
        outline: 0;
        border: none;

        width: 100%;
        padding: 10px;

        border-left: solid 1px #231f20;
        border-bottom: solid 1px #231f20;
        border-radius: 0 !important;
        //margin-bottom: 30px;
        
        box-shadow: none;
    }
    
    .btn {
        display: inline-block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 30px;
        width: auto;
        padding-left: 30px;
        padding-right: 30px;
        border: solid 1px #231f20;
        
        &:hover {
            color: white;
            background: #231f20;
        }
    }
}
</style>

<script>
import axios from "axios";
import querystring from "querystring";

export default {
  methods: {
    sendEmail() {
      this.$refs.submitButton.classList = "btn btn-block btn-warning";
      this.$refs.submitButton.innerHTML = '<i class="fa fa-spin fa-spinner"></i> Sending..';
      // honeypot
      if (!this.$refs.lastname.value && !this.$refs.address.value) {
        // not a bot
        if (
          this.$refs.name.value == "" ||
          this.$refs.email.value == "" ||
          this.$refs.phone.value == "" ||
          this.$refs.message.value == ""
        ) {
          this.$refs.submitButton.classList = "btn btn-block btn-danger";
          this.$refs.submitButton.innerHTML = '<i class="fa fa-times"></i> Please fill in required fields';
          setTimeout(() => {
            this.$refs.submitButton.classList = "btn btn-block btn-primary";
            this.$refs.submitButton.innerHTML = "Send";
          }, "3000");
        } else {
          // all fields input
          axios
            .post(
              "/scripts/sendEmail.php",
              querystring.stringify({
                name: this.$refs.name.value,
                phone: this.$refs.phone.value,
                email: this.$refs.email.value,
                beverage: this.$refs.beer.checked ? "Beer" : "Coffee",
                message: this.$refs.message.value
              })
            )
            .then(response => {
              if (response.error) {
                this.$refs.submitButton.classList = "btn btn-block btn-success";
                this.$refs.submitButton.innerHTML =
                  '<i class="fa fa-check"></i> Thanks for reaching out!';
              } else {
                this.$refs.submitButton.classList = "btn btn-block btn-success";
                this.$refs.submitButton.innerHTML =
                  '<i class="fa fa-check"></i> Thanks for reaching out!';
              }
            })
            .catch(() => {
              this.$refs.submitButton.classList = "btn btn-block btn-danger";
              this.$refs.submitButton.innerHTML =
                '<i class="fa fa-times"></i> Could not send email at this time';
            });
        }
      }
    }
  }
};
</script>
